import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from 'react-calendar-timeline';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import axios from 'axios';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import UpdateAdvBooking from './UpdateAdvBooking';
import './react-datepicker-override.css';

var keys = {
  groupIdKey: 'id',
  groupTitleKey: 'title',
  groupRightTitleKey: 'rightTitle',
  itemIdKey: 'id',
  itemTitleKey: 'title',
  itemDivTitleKey: 'title',
  itemGroupKey: 'group',
  itemTimeStartKey: 'start',
  itemTimeEndKey: 'end',
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    textAlign: 'start',
    margin: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
  componentTitle: {
    color: '#142966',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '24px',
    marginBottom: '0px',
  },
  separatorLine: {
    height: '2px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
    background: '#004878',
    border: 'none',
  },
  table: {
    minWidth: 650,
  },
  button: {
    maxWidth: '320px',
    width: '100%',
    marginBottom: '24px',
    marginTop: '24px',
    alignSelf: 'center',
  },
}));

function AdvanceBookings() {
  const navigate = useNavigate();
  const classes = useStyles();

  const [roomDetails, setRoomDetails] = useState(new Array<any>());
  const [allRoomsDetails, setAllRoomDetails] = useState([]);
  const [roomTypes, setRoomTypes] = useState<Array<string>>([]);
  const [advanceBookings, setAdvanceBookings] = useState(new Array<any>());
  const [bookingItems, setBookingItems] = useState(new Array<any>());
  const [selectedBooking, setSelectedBooking] = useState<any>();
  const [open, setOpen] = React.useState(false);
  const [updateOpen, setUpdateOpen] = React.useState(false);
  const [loadingCreateBooking, setLoadingCreateBooking] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleUpdateOpen = () => setUpdateOpen(true);
  const handleUpdateClose = () => setUpdateOpen(false);
  const [startDateValue, setStartDateValue] = useState(dayjs().toDate());
  const [endDateValue, setEndDateValue] = useState(
    dayjs().add(1, 'day').toDate()
  );

  const [visibleTimeStart, setVisibleTimeStart] = useState(
    moment().startOf('day').valueOf()
  );
  const [visibleTimeEnd, setVisibleTimeEnd] = useState(
    moment().startOf('day').add(1, 'day').valueOf()
  );
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [checkInDetails, setCheckInDetails] = useState(Array<any>());
  const [checkOutDetails, setCheckOutDetails] = useState(Array<any>());
  const [totalRoomDetails, setTotalRoomDetails] = useState(Array<any>());
  const [pendingCheckInDetails, setPendingCheckInDetails] = useState(
    Array<any>()
  );

  const handleSummaryOpen = () => setSummaryOpen(true);
  const handleSummaryClose = () => setSummaryOpen(false);

  const [viewMode, setViewMode] = useState('day');

  const [formData, setFormData] = useState({
    name: '',
    mobile_no: '',
    email: '',
    room_type: '',
    no_of_rooms: '',
    room_no: '',
  });

  useEffect(() => {
    fetchRoomDetails();
    fetchAdvanceBookings();
  }, []);

  const handleTimeChange = (
    visibleTimeStart: any,
    visibleTimeEnd: any,
    updateScrollCanvas: any,
    newViewMode: any
  ) => {
    setVisibleTimeStart(visibleTimeStart);
    setVisibleTimeEnd(visibleTimeEnd);
    updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
    setViewMode(newViewMode);
  };

  const onPrevClick = () => {
    setVisibleTimeStart(
      (prevStartTime) => prevStartTime - (visibleTimeEnd - visibleTimeStart)
    );
    setVisibleTimeEnd(
      (prevEndTime) => prevEndTime - (visibleTimeEnd - visibleTimeStart)
    );
  };

  const onNextClick = () => {
    setVisibleTimeStart(
      (prevStartTime) => prevStartTime + (visibleTimeEnd - visibleTimeStart)
    );

    setVisibleTimeEnd(
      (prevEndTime) => prevEndTime + (visibleTimeEnd - visibleTimeStart)
    );
  };

  const fetchRoomDetails = async () => {
    try {
      const result = await axios('/api/getAllRooms');
      setAllRoomDetails(result.data);
      const formatedData = result.data.map((room: any, index: number) => ({
        id: room.room_no,
        title: `${room.room_no} - ${room.description}`,
        height: 60,
      }));
      setRoomDetails(formatedData);
      const roomType: [string] = result.data.map(
        (room: any) => room.description as string
      );
      const uniqueRoomTypes = Array.from(new Set(roomType));
      setRoomTypes(uniqueRoomTypes);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAdvanceBookings = async () => {
    try {
      const result = await axios('/api/getAdvanceBookings');
      const advBookings = result.data;
      setAdvanceBookings(advBookings);

      const items = result.data
        .filter((item: any) => !item.deleted_at)
        .map((item: any) => ({
          id: item.adv_booking_id,
          group: item.room_no,
          title: item.name,
          start: moment(item.booking_start)
            .subtract(5, 'hours')
            .subtract(30, 'minutes'),
          end: moment(item.booking_end)
            .subtract(5, 'hours')
            .subtract(30, 'minutes'),
          canMove: false,
          canResize: false,
          canChangeGroup: false,
          itemProps: {
            onDoubleClick: () => {
              getSelectedRoomInfo(item.adv_booking_id, advBookings);
              handleUpdateOpen();
            },
          },
        }));
      setBookingItems(items);
    } catch (err) {
      console.error(err);
    }
  };

  const getSelectedRoomInfo = (advBookingId: any, advanceBookings: any) => {
    let roomInfo;
    for (let i = 0; i < advanceBookings.length; i++) {
      if (advanceBookings[i].adv_booking_id === advBookingId) {
        roomInfo = advanceBookings[i];
        break;
      }
    }

    if (roomInfo && Object.keys(roomInfo).length === 0) {
      alert('No additional details found.');
    } else {
      const formattedData = {
        checkedIn: roomInfo.checked_in,
        advBookingId: roomInfo.adv_booking_id,
        name: roomInfo.name,
        mobileNo: roomInfo.mobile_no,
        emailAddress: roomInfo.email_address,
        bookingStart: roomInfo.booking_start,
        bookingEnd: roomInfo.booking_end,
        roomNo: roomInfo.room_no,
        roomType: roomInfo.room_type,
        roomDetailsId: roomInfo.room_details_id,
        tenant_id: roomInfo.tenant_id,
      };

      setSelectedBooking(formattedData);
    }
  };

  async function handleCreateBooking(e: any) {
    e.preventDefault();
    setLoadingCreateBooking(true);
    const startDateTime = moment(startDateValue).format(
      'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
    );
    const endDateTime = moment(endDateValue).format(
      'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
    );

    const formCreateData = {
      name: formData.name,
      mobile_no: formData.mobile_no,
      email: formData.email,
      room_type: formData.room_type,
      no_of_rooms: formData.no_of_rooms,
      start_date: startDateTime,
      end_date: endDateTime,
    };

    try {
      const response = await axios.post(
        '/api/createAdvanceBooking',
        formCreateData
      );

      if (response.status === 200) {
        alert(response.data);
        handleClose();
        await fetchAdvanceBookings();
        setFormData({
          name: '',
          mobile_no: '',
          email: '',
          room_type: '',
          no_of_rooms: '',
          room_no: '',
        });
        setStartDateValue(dayjs().toDate());
        setEndDateValue(dayjs().add(1, 'day').toDate());
      } else if (response.status === 409) {
        alert(response.data);
      } else {
        alert('Error: ' + response.data);
      }
    } catch (error) {
      alert('Error creating booking(s)');
      console.error('Error creating booking:', error);
    }
    setLoadingCreateBooking(false);
    handleClose();
  }

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const getCurrentDateStats = () => {
    fetchAdvanceBookings();
    const sDate = moment(visibleTimeStart).format('YYYY-MM-DD HH:mm:ss');
    const eDate = moment(visibleTimeEnd).format('YYYY-MM-DD HH:mm:ss');

    const checkInDetails = new Map();
    const checkOutDetails = new Map();
    const totalRoomDetails = new Map();
    const pendingCheckInDetails = new Map();

    advanceBookings.forEach((booking: any) => {
      const roomType = booking.room_type;

      //Check-in pending
      if (booking.booking_start < sDate && booking.checked_in === 0) {
        if (!pendingCheckInDetails.has(roomType)) {
          pendingCheckInDetails.set(roomType, []);
        }
        pendingCheckInDetails.get(roomType).push({
          advBookingId: booking.adv_booking_id,
          name: booking.name,
          roomNo: booking.room_no,
          checkInDate: booking.booking_start,
          mobileNo: booking.mobile_no,
          status: booking.checked_in !== 0,
        });
      }

      // Partial check-in
      if (sDate <= booking.booking_start && booking.booking_start <= eDate) {
        if (!checkInDetails.has(roomType)) {
          checkInDetails.set(roomType, []);
        }
        console.log(booking);
        checkInDetails.get(roomType).push({
          advBookingId: booking.adv_booking_id,
          name: booking.name,
          roomNo: booking.room_no,
          checkInDate: booking.booking_start,
          mobileNo: booking.mobile_no,
          status: booking.checked_in !== 0,
        });
      }

      // Partial check-out
      if (sDate <= booking.booking_end && booking.booking_end <= eDate) {
        if (!checkOutDetails.has(roomType)) {
          checkOutDetails.set(roomType, []);
        }

        checkOutDetails.get(roomType).push({
          name: booking.name,
          roomNo: booking.room_no,
          checkInDate: booking.booking_start,
          mobileNo: booking.mobile_no,
          status: booking.checked_in !== 0,
        });
      }

      // Booking overlaps with the date range
      if (booking.booking_start <= eDate && booking.booking_end >= sDate) {
        if (!totalRoomDetails.has(roomType)) {
          totalRoomDetails.set(roomType, 0);
        }
        totalRoomDetails.set(roomType, totalRoomDetails.get(roomType) + 1);
      }
    });

    const checkInDetailsArray = Array.from(checkInDetails.entries());
    const checkOutDetailsArray = Array.from(checkOutDetails.entries());
    const totalRoomDetailsArray = Array.from(totalRoomDetails.entries());
    const pendingCheckInDetailsArray = Array.from(
      pendingCheckInDetails.entries()
    );

    setCheckInDetails(checkInDetailsArray);
    setCheckOutDetails(checkOutDetailsArray);
    setTotalRoomDetails(totalRoomDetailsArray);
    setPendingCheckInDetails(pendingCheckInDetailsArray);

    handleSummaryOpen();
  };

  return (
    <div className={classes.root}>
      <Button
        color="secondary"
        variant="contained"
        size="large"
        onClick={handleOpen}
        style={{ maxWidth: 280, alignSelf: 'center', marginBottom: 24 }}
      >
        Create Booking
      </Button>

      <Modal
        open={summaryOpen}
        onClose={handleSummaryClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            maxHeight: '80%',
            overflowY: 'auto',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Button
            onClick={handleSummaryClose}
            style={{ marginTop: '10px', left: '90%' }}
          >
            Close
          </Button>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h2>Summary - {moment(visibleTimeStart).format('Do MMMM YYYY')}</h2>
          </Typography>

          <Typography
            variant="subtitle1"
            component="h3"
            style={{ marginTop: '10px' }}
          >
            Check-In Details
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="check-in table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Contact</b>
                  </TableCell>
                  <TableCell>
                    <b>Room No</b>
                  </TableCell>
                  <TableCell>
                    <b>Check-In</b>
                  </TableCell>
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {checkInDetails.length === 0 &&
                pendingCheckInDetails.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No check-ins
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {/* Check-In Details */}
                    {checkInDetails.length > 0 &&
                      checkInDetails.map(([roomType, detailsArray]) =>
                        detailsArray.map((detail: any, index: number) => (
                          <TableRow key={`checkIn-${roomType}-${index}`}>
                            <TableCell>{detail.name}</TableCell>
                            <TableCell>{detail.mobileNo}</TableCell>
                            <TableCell>{detail.roomNo}</TableCell>
                            <TableCell>
                              {moment(detail.checkInDate)
                                .subtract(5, 'hours')
                                .subtract(30, 'minutes')
                                .format('Do MMM / hh:mm A')}
                            </TableCell>
                            <TableCell>
                              <button
                                onClick={() => {
                                  getSelectedRoomInfo(
                                    detail.advBookingId,
                                    advanceBookings
                                  );
                                  if (selectedBooking) {
                                    navigate('/updateCheckin', {
                                      state: { selectedBooking },
                                    });
                                  }
                                }}
                                style={{
                                  padding: '8px 20px',
                                  backgroundColor: detail.status
                                    ? '#FF0000'
                                    : '#38b000',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: detail.status
                                    ? 'not-allowed'
                                    : 'pointer',
                                  width: '80%',
                                }}
                              >
                                {detail.status
                                  ? 'Checked-In'
                                  : 'Not Checked-In'}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))
                      )}

                    {/* Pending Check-In Details */}
                    {pendingCheckInDetails.length > 0 &&
                      pendingCheckInDetails.map(([roomType, detailsArray]) =>
                        detailsArray.map((detail: any, index: number) => (
                          <TableRow key={`pendingCheckIn-${roomType}-${index}`}>
                            <TableCell>{detail.name}</TableCell>
                            <TableCell>{detail.mobileNo}</TableCell>
                            <TableCell>{detail.roomNo}</TableCell>
                            <TableCell>
                              {moment(detail.checkInDate)
                                .subtract(5, 'hours')
                                .subtract(30, 'minutes')
                                .format('DD-MM-YYYY hh:mm A')}
                            </TableCell>
                            <TableCell>
                              <button
                                onClick={() => {
                                  getSelectedRoomInfo(
                                    detail.advBookingId,
                                    advanceBookings
                                  );
                                  if (selectedBooking) {
                                    navigate('/updateCheckin', {
                                      state: { selectedBooking },
                                    });
                                  }
                                }}
                                style={{
                                  padding: '8px 20px',
                                  backgroundColor: '#FFDB00',
                                  color: 'black',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  width: '80%',
                                }}
                              >
                                {'Check-In Pending'}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Typography
            variant="subtitle1"
            component="h3"
            style={{ marginTop: '10px' }}
          >
            Check-Out Details
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="check-out table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Contact</b>
                  </TableCell>
                  <TableCell>
                    <b>Room No</b>
                  </TableCell>
                  <TableCell>
                    <b>Check-Out</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {checkOutDetails.length > 0 ? (
                  checkOutDetails.map(([roomType, detailsArray]) =>
                    detailsArray.map((detail: any, index: number) => (
                      <TableRow key={`checkOut-${roomType}-${index}`}>
                        <TableCell>{detail.name}</TableCell>
                        <TableCell>{detail.mobileNo}</TableCell>
                        <TableCell>{detail.roomNo}</TableCell>
                        <TableCell>
                          {moment(detail.checkInDate)
                            .subtract(5, 'hours')
                            .subtract(30, 'minutes')
                            .format('DD-MM-YYYY hh:mm A')}
                        </TableCell>
                      </TableRow>
                    ))
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No check-outs
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography
            variant="subtitle1"
            component="h3"
            style={{ marginTop: '10px' }}
          >
            <b>Room Availability</b>
            <p>(*Includes advance bookings)</p>
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="total room details table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Room Type</b>
                  </TableCell>
                  <TableCell>
                    <b>Occupied</b>
                  </TableCell>
                  <TableCell>
                    <b>Vacant</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from(
                  new Set(allRoomsDetails.map((room: any) => room.description))
                ).map((roomType) => {
                  const occupiedCount =
                    totalRoomDetails.find(
                      (entry) => entry[0] === roomType
                    )?.[1] || 0;
                  const totalRoomCount = allRoomsDetails.filter(
                    (r: any) => r.description === roomType
                  ).length;
                  const vacantCount = totalRoomCount - occupiedCount;

                  return (
                    <TableRow key={`totalRoom-${roomType}`}>
                      <TableCell>{roomType}</TableCell>
                      <TableCell>{occupiedCount}</TableCell>
                      <TableCell>{vacantCount}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Create Booking
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <form
                  onSubmit={handleCreateBooking}
                  style={{ maxWidth: '400px', margin: '0 auto' }}
                >
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                    style={{
                      marginBottom: '10px',
                      display: 'block',
                      padding: '5px',
                      width: '100%',
                    }}
                    required
                  />
                  <input
                    type="tel"
                    name="mobile_no"
                    value={formData.mobile_no}
                    onChange={handleChange}
                    placeholder="Mobile No."
                    style={{
                      marginBottom: '10px',
                      display: 'block',
                      padding: '5px',
                      width: '100%',
                    }}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    style={{
                      marginBottom: '10px',
                      display: 'block',
                      padding: '5px',
                      width: '100%',
                    }}
                  />
                  <select
                    name="room_type"
                    value={formData.room_type}
                    onChange={handleChange}
                    placeholder="Room Type"
                    style={{
                      marginBottom: '10px',
                      display: 'block',
                      padding: '5px',
                      width: '100%',
                    }}
                    required
                  >
                    <option value="">Select</option>
                    {roomTypes.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                  <input
                    type="number"
                    name="no_of_rooms"
                    value={formData.no_of_rooms}
                    onChange={handleChange}
                    placeholder="No. of Rooms"
                    style={{
                      marginBottom: '10px',
                      display: 'block',
                      padding: '5px',
                      width: '100%',
                    }}
                    required
                  />

                  <div
                    style={{
                      marginBottom: '10px',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ marginRight: '10px' }}>
                      Start date:
                      <br />
                      <DatePicker
                        selected={startDateValue}
                        showTimeSelect
                        dateFormat="dd-MMM-yy,  hh:mm aa"
                        onChange={(date) => setStartDateValue(date as Date)}
                        minDate={dayjs().add(1, 'day').startOf('day').toDate()}
                      />
                    </div>

                    <div>
                      End date:
                      <br />
                      <DatePicker
                        selected={endDateValue}
                        showTimeSelect
                        dateFormat="dd-MMM-yy,  hh:mm aa"
                        onChange={(date) => setEndDateValue(date as Date)}
                        minDate={dayjs().add(1, 'day').startOf('day').toDate()}
                      />
                    </div>
                  </div>

                  <Button
                    type="submit"
                    style={{
                      padding: '8px 12px',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      width: '100%',
                    }}
                    disabled={loadingCreateBooking}
                  >
                    {loadingCreateBooking
                      ? 'Creating Booking...'
                      : 'Create Booking'}
                  </Button>
                </form>
              </Typography>
            </Box>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={updateOpen}
        onClose={handleUpdateClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {selectedBooking && (
              <UpdateAdvBooking
                selectedBooking={selectedBooking}
                closeModal={handleUpdateClose}
                onUpdate={fetchAdvanceBookings}
              />
            )}
          </Typography>
        </Box>
      </Modal>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <Button
          variant="contained"
          onClick={onPrevClick}
          style={{ marginLeft: '10px' }}
        >
          {'< Prev'}
        </Button>

        {viewMode === 'day' && (
          <Button variant="contained" onClick={getCurrentDateStats}>
            Get Summary
          </Button>
        )}
        <Button
          variant="contained"
          onClick={onNextClick}
          style={{ marginRight: '10px' }}
        >
          {'Next >'}
        </Button>
      </div>
      <Timeline
        lineHeight={60}
        groups={roomDetails}
        items={bookingItems}
        keys={keys}
        sidebarWidth={150}
        itemTouchSendsClick={false}
        itemHeightRatio={0.75}
        visibleTimeStart={visibleTimeStart}
        visibleTimeEnd={visibleTimeEnd}
        buffer={1}
        onTimeChange={handleTimeChange}
      ></Timeline>
    </div>
  );
}

export default AdvanceBookings;
